<template>
  <Sidebar v-model:visible="visibleProfile" header="Edit Profile" class="profile-side" position="right" :modal="false"
           :draggable="false">
    <header class="flex justify-center">
      <div class="border-b-[1px] text-1xl font-bold">
        <i class="uil uil-user-circle"></i>
        Миний профайл
      </div>
    </header>
    <form class="card-body w-full" :model="ruleForm" :rules="rules" ref="ruleForm">
      <div class="md:flex md:items-center mb-6 pt-6">
        <div class="md:w-1/3">
          <label class="block md:text-right mb-1 md:mb-0 pr-4">
            <span class="label-text">Зураг:</span>
          </label>
        </div>

        <div class="md:w-2/3">
          <div style="width: 90%">
            <div style="display: flex; flex-direction: row; gap:20px; align-items: center">
              <div class="avatar justify-center" v-if="ruleForm.image">
                <div class="rounded-full" style="height: 180px; width: 180px">
                  <img :src="config.HOST +ruleForm.image" class="rounded-full"
                       style="object-fit: cover; width: 100%; height: 100%;">
                </div>
              </div>
              <FileUpload
                  mode="basic" name="file" :url="config.HOST+ '/lambda/krud/upload'"
                  :chooseLabel="ruleForm.image ==null?'Зураг сонгох':'Зураг солих'"
                  accept="image/*" :maxFileSize="2000000" :auto="true"
                  @upload="upload($event)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label class="block md:text-right mb-1 md:mb-0 pr-4">
            <span class="label-text">Овог:</span>
          </label>
        </div>
        <div class="md:w-2/3">
          <InputText class="seeroo-input" v-model="ruleForm.lastname" invalid placeholder="Таны овог"/>
          <!--          <br>-->
          <!--          <small id="username-help">Enter your username to reset your password.</small>-->
          <!--          <input type="text" placeholder="Таны овог"-->
          <!--                 class="input input-bordered hover:border-accent w-full md:w-3/4" v-model="ruleForm.lastname">-->
        </div>
      </div>
      <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label class="block md:text-right mb-1 md:mb-0 pr-4">
            <span class="label-text">Нэр:</span>
          </label>
        </div>
        <div class="md:w-2/3">
          <InputText class="seeroo-input" v-model="ruleForm.firstname" invalid placeholder="Таны нэр"/>
        </div>
      </div>
      <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label class="block md:text-right mb-1 md:mb-0 pr-4">
            <span class="label-text">И-мэйл:</span>
          </label>
        </div>
        <div class="md:w-2/3">
          <InputText class="seeroo-input" v-model="ruleForm.email" invalid placeholder="И-мэйл хаяг"/>
          <!--          <input type="text" placeholder="И-мэйл хаяг"-->
          <!--                 class="input input-bordered hover:border-accent w-full md:w-3/4" v-model="ruleForm.nickename">-->
        </div>
      </div>
      <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label class="block md:text-right mb-1 md:mb-0 pr-4">
            <span class="label-text">Утас:</span>
          </label>
        </div>
        <div class="md:w-2/3">
          <InputText class="seeroo-input" v-model="ruleForm.phone" invalid placeholder="Таны утасны"/>
          <!--          <br>-->
          <!--          <small id="username-help">Enter your username to reset your password.</small>-->
          <!--          <input type="text" placeholder="Таны овог"-->
          <!--                 class="input input-bordered hover:border-accent w-full md:w-3/4" v-model="ruleForm.lastname">-->
        </div>
      </div>
      <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label class="block md:text-right mb-1 md:mb-0 pr-4">
            <span class="label-text">Нас:</span>
          </label>
        </div>
        <div class="md:w-2/3">
          <InputText class="seeroo-input" v-model="ruleForm.age" invalid placeholder="Таны нас"/>
          <!--          <br>-->
          <!--          <small id="username-help">Enter your username to reset your password.</small>-->
          <!--          <input type="text" placeholder="Таны овог"-->
          <!--                 class="input input-bordered hover:border-accent w-full md:w-3/4" v-model="ruleForm.lastname">-->
        </div>
      </div>
      <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label class="block md:text-right mb-1 md:mb-0 pr-4">
            <span class="label-text">Хүйс:</span>
          </label>
        </div>
        <div v-for="gender in genders" :key="gender.key" class="flex align-items-center">
          <RadioButton class="seeroo-radio" v-model="ruleForm.gender" :inputId="gender.id" name="dynamic"
                       :value="gender.id"/>
          <label :for="gender.id" class="ml-2 mr-4">{{ gender.name }}</label>
        </div>
      </div>
      <div class="md:flex md:items-center">
        <div class="md:w-1/3"></div>
        <div class="w-full md:w-2/3 mt-5">
          <Button label="Хадгалах" class="p-button-sm text-white" severity="success" @click="submitForm('ruleForm')"/>
          <Button label="Болих" class="p-button-sm ml-5" @click="closePage"/>
        </div>
      </div>
    </form>
  </Sidebar>

</template>

<script>

import Sidebar from 'primevue/sidebar';
// import InputText from 'primevue/inputtext';
import RadioButton from 'primevue/radiobutton';
import Button from 'primevue/button';
import baseApi from "@store/_boot/baseApi";
import config from "@store/_boot/config";
// import axios from "axios";
import FileUpload from 'primevue/fileupload';
import {mapActions} from "vuex";

export default {
  name: "ProfileSidebar",
  props: ['user'],
  components: {
    Sidebar,
    Button,
    FileUpload,
    RadioButton
  },
  data() {
    return {
      visibleProfile: false,
      ruleForm: {
        userId:null,
        image: null,
        firstname: null,
        lastname: null,
        email: null,
        gender: null,
        age: null,
        dialogImageUrl: '',
        dialogVisible: false
      },
      genders: [
        {
          id: '1',
          name: 'Эрэгтэй'
        },
        {
          id: '2',
          name: 'Эмэгтэй'
        },
      ],
      rules: {
        firstname: [
          {required: true, message: 'Нэрээ оруулна уу!', trigger: 'blur'},
          {min: 3, max: 5, message: 'Таны нэр 3-5 тэмдэгт орсон байх ёстой.', trigger: 'blur'}
        ],
        lastname: [
          {required: true, message: 'Овгоо оруулна уу!', trigger: 'blur'},
          {min: 3, max: 5, message: 'Таны овог 3-5 тэмдэгт орсон байх ёстой.', trigger: 'blur'}
        ],
        email: [
          {required: true, message: 'Имэйлээ оруулна уу!', trigger: 'blur'},
          {min: 3, max: 5, message: 'Таны оруулсан утга имэйл төрлийнх орсон байх ёстой.', trigger: 'blur'}
        ],
        gender: [
          {required: true, message: 'Хүйсээ сонгоно уу!', trigger: 'change'}
        ]
      }
    }
  },
  created() {
    console.log('user sidebar profile', this.user)
    if (this.user) {
      this.ruleForm.userId = this.user.id;
      this.ruleForm.firstname = this.user.first_name
      this.ruleForm.lastname = this.user.last_name
      this.ruleForm.email = this.user.email
      this.ruleForm.image = this.user.image
      this.ruleForm.gender = this.user.gender
      this.ruleForm.phone = this.user.phone
      this.ruleForm.age = this.user.age
    }
  },
  computed: {
    config() {
      return config
    }
  },
  methods: {
    ...mapActions(['saveUserInfo']),
    baseApi,
    uploadImage(e) {
      console.log('image');
      const file = e.target.files[0];
      this.ruleForm.image = file.name;
      console.log(file);
      console.log(this.ruleForm);
    },

    upload(event) {
      // this.idImageEdit = true;
      this.ruleForm.image = event.xhr.responseText;
    },
    submitForm() {
      this.saveUserInfo(({vm: this}))
      // console.log(this.$refs['ruleForm']);
      // console.log(this.ruleForm);
      // axios.post(`${this.baseUrl}/api/m/update/profile/${this.userId}`, this.ruleForm).then(({data}) => {
      //   if (data.status) {
      //     // this.$notify.success({
      //     //   title: 'Амжилттай',
      //     //   message: 'Таны nickname амжилттай бүртгэгдлээ.'
      //     // });
      //   } else {
      //     // this.$notify.error({
      //     //   title: 'Nickname бүртгэх боломжгүй байна',
      //     //   message: 'Таны сонгосон nickname давхцаж байгаа тул өөр нэр сонгоод дахин илгээнэ үү.'
      //     // });
      //   }
      //
      //   this.isLoadingNickname = false;
      // })
      // this.$refs['ruleForm'].validate((valid) => {
      //   console.log('valid', valid);
      //   if (valid) {
      //     alert('submit!');
      //   } else {
      //     console.log('error submit!!');
      //     return false;
      //   }
      // });
    },
    resetForm() {
      this.ruleForm = {

        image: null,
        firstname: null,
        lastname: null,
        gender: null,
        email: null,
        dialogImageUrl: '',
        dialogVisible: false
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    closePage() {
      this.visibleProfile = false;
    },
    onChangePin(pin) {
      if (pin.length === 4) {
        this.ruleForm.pin = pin;
      }
    },

    onCompletePin(val) {
      this.ruleForm.pin = val;
    },

    onChangeNewPin(newPin) {
      if (newPin.length === 4) {
        this.ruleForm.newPin = newPin;
      }
    },

    onCompleteNewPin(val) {
      if (val.length === 4) {
        this.ruleForm.newPin = val;
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    changePin() {
      console.log('user' + this.user.phone);
      this.changePass(({vm: this}));
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
